// prestitialForecastingMode.js
//
// This script is used to define the ad unit for the prestitial ad.
// It is used in forecasting mode, where the ad unit is not defined in the head.html file.
// i.e when prestitial is disabled
//

// copied from prestitial.js
function screenMeetsSizeReqs() {
  return window.innerWidth > 640 && window.innerHeight > 640;
}

// copied from prestitial.js
function userIsPrestitialEligible() {
  return (
    (document.cookie.indexOf('_prestitialViewed') === -1)
    && (window.location.href.indexOf('?prestitial_skip') === -1)
  );
}

// copied from prestitial.js
function pageIsPrestitialEligible() {
  return screenMeetsSizeReqs() && userIsPrestitialEligible();
}

// copied from prestitial.js and modifies to make it readable
function setCookie(cName, value, expireDays) {
  const exdate = new Date();
  exdate.setDate(exdate.getDate() + expireDays);
  let cookieString = `${cName}=${encodeURIComponent(value)}`;
  if (expireDays !== null) {
    cookieString += `;expires=${exdate.toUTCString()}`;
  }
  cookieString += '; path=/';
  document.cookie = cookieString;
}

function setPrestitialViewedCookie() {
//   console.log(Date.now(), 'log_PTL', 'setPrestitialViewedCookie');
  if (document.cookie.indexOf('_prestitialViewed') === -1) {
    setCookie('_prestitialViewed', Date.now(), window.days_between_prestitial);
  }
}

function defineAdUnit() {
//   console.log(Date.now(), 'log_PTL', 'pageIsPrestitialEligible()', pageIsPrestitialEligible());
  if (pageIsPrestitialEligible()) {
    const adUnit = `${window.dfp_ad_unit_prefix}prestitial`;
    // eslint-disable-next-line no-undef
    window.googletag.defineSlot(adUnit, [[500, 300], [640, 480]], 'paychekgoeshere').addService(googletag.pubads());
    // console.log(Date.now(), 'log_PTL', 'adUnit defined', adUnit);
    setPrestitialViewedCookie();
  }
}

let googleTagCheckRetries = 0;
const MAX_GOOGLE_TAG_RETRIES = 10;

function checkIfGoogleTagIsDefined() {
  // googletag is defined in head.html
  if (window.googletag && typeof window.googletag.defineSlot === 'function') {
    // console.log(Date.now(), 'log_PTL', 'googletag.defineSlot is defined');
    // run defineAdUnit after googletag.defineSlot is defined
    defineAdUnit();
  } else if (googleTagCheckRetries < MAX_GOOGLE_TAG_RETRIES) {
    // check again in 1 second
    setTimeout(checkIfGoogleTagIsDefined, 1000);
    googleTagCheckRetries += 1;
  } else {
    throw new Error('googletag.defineSlot is not defined max retries reached');
  }
}

checkIfGoogleTagIsDefined();
